const POPULAR_MAKES = ['audi', 'seat', 'skoda', 'volkswagen', 'cupra'];
export { POPULAR_MAKES };
